import React, { PropTypes, Component } from 'react';
import TaskFeedback from './TaskFeedback';
import * as Icons from 'components/Material/SvgIcons';
import ProfileImage from 'components/Widgets/ProfileImage';
import { Shadow, Colors, Units } from 'Css';

const css = oxygenCss({
  root: {
    boxShadow: Shadow[1],
    backgroundColor: Colors.theme.Light.card,
    padding: Units.base,
    margin: Units.base
  },
  userName: {
    marginLeft: Units.base,
    fontSize: 24,
    display: 'inline-block'
  }
});

export default class RadioTaskResult extends Component {
  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  render() {
    let { body, choices, user, correctResponse, created } = this.props;
    let { value } = body;
    let response;
    let correctAnswers = (correctResponse && correctResponse.value) || [];
    if (correctAnswers && correctAnswers.length > 0) {
      let answers = [];
      correctAnswers.forEach((correctAnswer, i) => {
        let label = choices[correctAnswer];
        let color;
        let icon;
        if (value.indexOf(correctAnswer) > -1) {
          color = Colors.material.green[500].hex;
          icon = <Icons.NavigationCheck style={{ verticalAlign: 'middle' }} />;
          answers.push([{text: ' - ' + label}, color, icon]);
        } else {
          color = Colors.material.red[800].hex;
          icon = <Icons.NavigationClose style={{ verticalAlign: 'middle' }} />;
          if (i > 0 || correctAnswers.length > 1) {
            answers.push([{text: 'missed - ' + label}, color, icon]);
          } else {
            const newLabel = choices[value[0]];
            answers.push([{text: ' - ' + newLabel}, color, icon]);
          }
        }
      });
      if (value.length > correctAnswers.length && answers.length === correctAnswers.length) {
        const neededValue = value.filter(val => correctAnswers.indexOf(val) === -1);
        const color = Colors.material.red[800].hex;
        const icon = <Icons.NavigationClose style={{ verticalAlign: 'middle' }} />;
        answers.push([{text: 'missed - ' + choices[neededValue[0]]}, color, icon]);
      }
      response = (
        <TaskFeedback
          leftIcon={<Icons.SocialPersonOutline />}
          answers={answers}
          created={created}
        />
      );
    } else {
      let color;
      let icon;
      if (correctAnswers.length < 1) {
        color = Colors.material.green[500].hex;
        icon = <Icons.NavigationCheck style={{ verticalAlign: 'middle' }} />;
      } else {
        color = Colors.material.red[800].hex;
        icon = <Icons.NavigationClose style={{ verticalAlign: 'middle' }} />;
      }
      response = (
        <TaskFeedback
          leftIcon={<Icons.SocialPersonOutline />}
          answers={[[{text: this.context.getIntlMessage('tasks.noAnswer')}, color]]}
          rightIcon={icon}
          created={created}
        />
      );
    }
    return (
      <div className={css.root}>
        {response}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/Task/RadioTaskResult.js